/**
 *                                     _      _  
 *    __ _ _ __ ___  ___ _ ____      _(_) ___| |__  
 *   / _` | '__/ _ \/ _ \ '_ \ \ /\ / / |/ __| '_ \
 *  | (_| | | |  __/  __/ | | \ V  V /| | (__| | | |
 *   \__, |_|  \___|\___|_| |_|\_/\_/ |_|\___|_| |_|
 *   |___/          _                   _ _
 *                 | | ___  _   _  __ _| | |_ _   _
 *                 | |/ _ \| | | |/ _` | | __| | | |
 *                 | | (_) | |_| | (_| | | |_| |_| |
 *                 |_|\___/ \__, |\__,_|_|\__|\__, |
 *                          |___/             |___/
 *
 *                  https://www.greenwichloyalty.com
 *
**/

const appName = 'LoyaltyDashboardApp';
//const apiBaseUrl = 'http://localhost:40000';
const apiBaseUrl = 'https://dashboard-api.petstoployalty.ie';
const apiCallMaxRetries = 1; // 1 for testing purposes

const TIMESTAMP_FORMAT_ISO8601 = 'YYY-MM-DDTHH:mm:ss.SSSZ';
const DATETIME_FORMAT_HUMAN_READABLE = 'DD/MMM/YYYY HH:mm';

const DEFAULT_NEW_PROMOTION_LINK_URL = 'https://www.petstop.ie';

const FILES_S3_STORAGE_BUCKET = 'files-dev.greenwichloyalty.com';
const FILES_S3_STORAGE_BUCKETX = 'files.greenwichloyalty.com';

global.appName = appName;
global.apiBaseUrl = apiBaseUrl;
global.apiCallMaxRetries = apiCallMaxRetries;
global.DATETIME_FORMAT_HUMAN_READABLE = DATETIME_FORMAT_HUMAN_READABLE;
global.TIMESTAMP_FORMAT_ISO8601 = TIMESTAMP_FORMAT_ISO8601;
global.DEFAULT_NEW_PROMOTION_LINK_URL = DEFAULT_NEW_PROMOTION_LINK_URL;
global.files_s3_storage_bucket = FILES_S3_STORAGE_BUCKET;
